/* eslint-disable global-require */
import angular from 'angular';
import MobileSellerAPIController from './mobile-seller.controller';

export default angular.module('autoboard.mobileSellerAPI', [])
  .controller('MobileSellerAPIController', MobileSellerAPIController)
  .name;
